import type { ContentDetailAPIResponse } from "@/models/content-detail-api-response";
import type { FetchError } from "ofetch";

export enum FetchContentStatus {
  SUCCESS = "success",
  NOT_FOUND = "not_found",
  ERROR = "other_error",
}

interface FetchContentDetailsResult {
  data: ContentDetailAPIResponse | null;
  status: FetchContentStatus;
}

const determineFetchStatus = (
  fetchError: FetchError | null | undefined,
): FetchContentStatus => {
  if (fetchError) {
    switch (fetchError.statusCode) {
      case 404:
        return FetchContentStatus.NOT_FOUND;
      default:
        return FetchContentStatus.ERROR;
    }
  }
  return FetchContentStatus.SUCCESS;
};

export async function fetchContentDetails(
  contentId: string,
): Promise<FetchContentDetailsResult> {
  const url: string = `${import.meta.env.VITE_API_BASE_URL}/content`;

  const { data: fetchedData, error: fetchError } =
    await useAsyncData<ContentDetailAPIResponse>(
      `fetch-content-${contentId}`,
      () =>
        $fetch<ContentDetailAPIResponse>(url, {
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
            Accept: "application/json",
          },
          params: {
            contentid: contentId,
          },
        }),
    );

  const status = determineFetchStatus(fetchError?.value);

  return {
    data: fetchedData.value ?? null,
    status,
  };
}

// TODO - new method --> check missing attribute from JSON return
